module.exports = __webpack_public_path__ + "static/img/GLORY.eb5b164.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/GLORY.png
// module id = nUqQ
// module chunks = 0